import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_3 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("AWS服务费用：")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isInserted)
      ? (_openBlock(), _createBlock(_component_page_wrapper, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_we_table, {
              onRegister: _ctx.register,
              activeKey: _ctx.tab,
              "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              aws_bill_account_id: _withCtx(({ text, record }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (_ctx.getAwsDetailByAccountId(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(text), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              spp_discount: _withCtx(({ text, record }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (_ctx.get_spp_table_data(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatNumber(text, '0,0.00')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              payer_action: _withCtx(({ record }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (_ctx.edit_aws_payer_account_item(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              headerButton: _withCtx(() => [
                (_ctx.is_aws_detail)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.change_type,
                        class: "mr-8"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`切换为${_ctx.type === 'month' ? '日期' : '月份'}`), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_month_picker, {
                        allowClear: "",
                        value: _ctx.month,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
                        valueFormat: "YYYY-MM",
                        onChange: _ctx.reload,
                        placeholder: "请选择月份"
                      }, null, 8, ["value", "onChange"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.is_payer_config)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit_aws_payer_account_item({})))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onRegister", "activeKey"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_we_table, { onRegister: _ctx.register }, {
            "g-action": _withCtx(({ record }) => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.editData(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.deleteData(record)),
                danger: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            headerButton: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editData({})))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onRegister"])
        ])),
    _createVNode(_component_a_modal, {
      title: _ctx.account_dialog_title,
      width: "1000px",
      visible: _ctx.account_dialog_visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.account_dialog_visible) = $event)),
      closable: false,
      maskClosable: "",
      okText: "导出",
      onOk: _ctx.export_html_page,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 12,
              style: {"text-align":"left","padding":"0 16px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("账户ID：" + _toDisplayString(_ctx.account_id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 12,
              style: {"text-align":"right","padding":"0 16px","font-size":"16px","font-weight":"700"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString('$' + _ctx.formatNumber(_ctx.get_all_header_cost(_ctx.aggregation), '0,0.00')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 12,
              style: {"text-align":"left","padding":"0 16px"}
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 12,
              style: {"text-align":"right","padding":"0 16px","font-size":"16px","font-weight":"700"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString('$' + _ctx.formatNumber(_ctx.get_all_header_cost(_ctx.aggregation), '0,0.00')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_collapse, { expandIconPosition: "left" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aggregation, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                key: index,
                header: item.service ? item.service : 'No Service'
              }, {
                extra: _withCtx(() => [
                  _createTextVNode(_toDisplayString('$' + _ctx.formatNumber(_ctx.get_header_cost(item), '0,0.00')), 1)
                ]),
                default: _withCtx(() => [
                  (item.val.length > 0)
                    ? (_openBlock(), _createBlock(_component_a_collapse, {
                        key: 0,
                        expandIconPosition: "left"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.val, (child, child_index) => {
                            return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                              key: child_index,
                              header: child.sku_region ? child.sku_region : 'No Region'
                            }, {
                              extra: _withCtx(() => [
                                _createTextVNode(_toDisplayString('$' + _ctx.formatNumber(_ctx.get_header_cost(child), '0,0.00')), 1)
                              ]),
                              _: 2
                            }, 1032, ["header"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["header"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "visible", "onOk"]),
    _createVNode(_component_a_modal, {
      title: _ctx.spp_dialog_title,
      width: "800px",
      visible: _ctx.spp_dialog_visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.spp_dialog_visible) = $event)),
      closable: false,
      maskClosable: "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_we_table, _mergeProps(_ctx.spp_table_config, { dataSource: _ctx.spp_table_data }), null, 16, ["dataSource"])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ], 64))
}